module.exports = __webpack_public_path__ + "img/logo_pautions_gris.035cd90d.svg";